import { DOCUMENT } from '@angular/common'
import { Injectable, inject, signal } from '@angular/core'

type ThemeMode = 'light' | 'dark'

const STORAGE_KEY = 'instalinker_theme'

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private document = inject(DOCUMENT)
  private currentTheme = signal<ThemeMode>('light')

  isDark = () => this.currentTheme() === 'dark'

  initTheme() {
    const stored = this.readStoredTheme()
    const mode = stored || 'dark'
    this.applyTheme(mode)
  }

  toggleTheme() {
    const next: ThemeMode = this.currentTheme() === 'dark' ? 'light' : 'dark'
    this.applyTheme(next)
  }

  private applyTheme(mode: ThemeMode) {
    this.currentTheme.set(mode)
    const root = this.document.documentElement
    root.classList.toggle('dark', mode === 'dark')
    root.style.colorScheme = mode
    this.persistTheme(mode)
  }

  private readStoredTheme(): ThemeMode | null {
    const value = localStorage.getItem(STORAGE_KEY)
    return value === 'dark' || value === 'light' ? value : null
  }

  private persistTheme(mode: ThemeMode) {
    localStorage.setItem(STORAGE_KEY, mode)
  }

}
